import { render } from "./addAccountModal.vue?vue&type=template&id=f08d90e6"
import script from "./addAccountModal.vue?vue&type=script&lang=js"
export * from "./addAccountModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__